<script setup>
import { computed } from 'vue';
import { useApiSlugs } from '@/composables/useApiSlugs';
import { useCmsPage } from '@/composables/useCmsPage';

import { useBlocks } from '@/composables/useBlocks';
import { useSeo } from '@/composables/useSeo';
import AosContainer from '@/components/AosContainer.vue';
const { getPageSlug } = useApiSlugs();
const blockComponents = useBlocks();
const apiSlug = computed(() => getPageSlug());

const { data } = await useCmsPage(apiSlug);

const isRedirect = computed(() => !!data.value?.redirect?.redirect_url);
const seoInput = computed(() => {
  const pageData = data.value?.data;
  if (!data.value?.success || isRedirect.value || !pageData) return null;

  return {
    title: pageData.seo_title || pageData.title || '',
    description: pageData.meta_description || '',
    keywords: pageData.meta_keywords || '',
    robots: pageData.meta_robots || 'index, follow',
    image: pageData.image_cover?.src || null,
    path: pageData.url || '',
  };
});

useSeo({
  title: computed(() => seoInput.value?.title),
  description: computed(() => seoInput.value?.description),
  keywords: computed(() => seoInput.value?.keywords),
  robots: computed(() => seoInput.value?.robots),
  image: computed(() => seoInput.value?.image),
  path: computed(() => seoInput.value?.path),
});
</script>

<template>
  <AosContainer
    v-if="data?.success && !isRedirect"
    :options="{ once: true, duration: 600, easing: 'ease-out' }"
  >
    <div v-if="data?.success" class="page-dynamic">
      <component
        :is="blockComponents[block.type]"
        v-for="(block, index) in data?.data?.sections"
        :id="block.id"
        :key="block.id"
        :data="block.data"
        :page-type="pageType"
        :is-first-section="index === 0"
      />
    </div>
  </AosContainer>
</template>
